import { getField, updateField } from 'vuex-map-fields'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import getTimeCardReportModel from '@/store/modules/models/timeCardReportFilters'

const timeCardReportFilters = {
  namespaced: true,
  state: buildInitialState({
    ...getTimeCardReportModel()
  }),
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearFilters: (state) => {
      state.startDate = null
      state.endDate = null
      state.clientId = null
      state.userId = null
      state.assignmentId = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      commit('clearFilters')
    }
  }
}

export default timeCardReportFilters
